export var FileKind;
(function (FileKind) {
    FileKind[FileKind["FILE"] = 0] = "FILE";
    FileKind[FileKind["FOLDER"] = 1] = "FOLDER";
    FileKind[FileKind["ROOT_FOLDER"] = 2] = "ROOT_FOLDER";
})(FileKind || (FileKind = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/files/common/files.js
// module id = 553
// module chunks = 58